module.exports = __webpack_public_path__ + "img/edit.3c04fba5.svg";